import { BoostingCampaign, PreferredValue } from "@vviinn/user-managment-client-ts";
import { RestrictedSiteCustomField } from "../../site";
import { productMutableFields } from "../../product/details/productMutableFields";
import { CampaignFilterType } from "../list/types";

export type PreferredValueDraft = { weight: number; rawValue: string };

export function inferColumnType(
  column: string | undefined,
  customFields: RestrictedSiteCustomField[],
): "string" | "number" {
  if (!column) return "string";
  const standardField = productMutableFields.find((f) => f.baseName === column);
  if (standardField)
    return standardField.type === "number" ? "number" : "string";
  const customField = customFields.find((f) => f.name === column);
  return customField?.type === "float" ? "number" : "string";
}

export function serializePreferredValues(
  drafts: PreferredValueDraft[],
): PreferredValue[] {
  return drafts
    .filter((d) => d.rawValue.trim() !== "")
    .map((d) => ({ value: d.rawValue, weight: d.weight }));
}

export function rawValueToNumber(rawValue: string | undefined): number | undefined {
  return rawValue?.trim() ? Number(rawValue) : undefined;
}

export function patchFirstPreferredDraft(
  current: PreferredValueDraft | undefined,
  patch: Partial<PreferredValueDraft>,
): PreferredValueDraft[] {
  return [{ weight: 1, rawValue: "", ...current, ...patch }];
}

export function deserializePreferredValues(
  preferred: PreferredValue[] | undefined,
): PreferredValueDraft[] {
  if (!preferred?.length) return [];
  return preferred.map((p) => ({ weight: p.weight, rawValue: p.value }));
}

export const selectBoosting = (
  boosting: BoostingCampaign[],
  search: string,
  activeOnly: boolean,
  filters: CampaignFilterType[],
  countById: Record<string, number>,
) => {
  if (filters.length > 0 && !filters.includes("BOOSTING")) return [];
  const lowercaseSearch = search.toLowerCase();
  return boosting.filter(({ id, name, column }) => {
    if (
      search &&
      !name.toLowerCase().includes(lowercaseSearch) &&
      !(column ?? "").toLowerCase().includes(lowercaseSearch)
    )
      return false;
    if (activeOnly && !(countById[id ?? ""] > 0)) return false;
    return true;
  });
};
